import { g as getCurrentBreakpoint } from './breakpoints-011b5bc5.js';

/**
 * It creates a new `ResizeObserver` instance and observes the elements returned by the `targets`
 * function
 *
 * @param {InjectPageResizeObserverEntry} [observerEntry] - InjectPageResizeObserverEntry - This is the object that contains the
 * callback function.
 * @returns {void} A decorator function that takes a component class as an argument.
 */
function InjectPageResizeObserver(observerEntry) {
  return (componentClass, currentBreakpointName) => {
    const { connectedCallback, componentDidLoad, disconnectedCallback } = componentClass;
    /* eslint-disable jsdoc/require-jsdoc */
    const createResizeObserver = (host, observerEntry) => {
      var _a;
      (_a = host.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
      const VegaResizeObserver = window['VegaResizeObserver'] || ResizeObserver;
      host.resizeObserver = new VegaResizeObserver(() => {
        if (observerEntry) {
          observerEntry.callback(host);
        }
        else {
          host[currentBreakpointName] = getCurrentBreakpoint();
        }
      });
      host.resizeObserver.observe((observerEntry === null || observerEntry === void 0 ? void 0 : observerEntry.target) ? observerEntry.target(host) : document.body);
    };
    componentClass.componentDidLoad = function () {
      createResizeObserver(this, observerEntry);
      return componentDidLoad === null || componentDidLoad === void 0 ? void 0 : componentDidLoad.call(this);
    };
    componentClass.connectedCallback = function () {
      if (this.resizeObserver === null) {
        createResizeObserver(this, observerEntry);
      }
      return connectedCallback === null || connectedCallback === void 0 ? void 0 : connectedCallback.call(this);
    };
    componentClass.disconnectedCallback = function () {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
      return disconnectedCallback === null || disconnectedCallback === void 0 ? void 0 : disconnectedCallback.call(this);
    };
  };
}

export { InjectPageResizeObserver as I };
